import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';

export class DropdownFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    placeholder: string;
    options: DropdownOptionModel[];
    ariaLabel: string;
    appearCondition?: (x: any) => boolean;
    panelStyleClass?: string;
    labelStyleClass?: string;
    changeOption?: (x: any, y: any) => void

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        options: DropdownOptionModel[],
        placeholder?: string,
        ariaLabel?: string,
        appearCondition?: (x: any) => boolean,
        panelStyleClass?: string,
        changeOption?: (x: any, y: any) => void,
        labelStyleClass?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.placeholder = placeholder;
        this.options = options;
        this.ariaLabel = ariaLabel;
        this.appearCondition = appearCondition;
        this.panelStyleClass = panelStyleClass;
        this.changeOption = changeOption;
        this.labelStyleClass = labelStyleClass;
    }
}
